export enum AutoCompleteComponent {
  Input = 'input',
  Textarea = 'textarea'
}

export type AutoCompleteSize = 'xs' | 's' | 'sm' | 'm' | 'md' | 'lg';

export type AutoCompleteFontSize = 's' | 'm';
